import { h } from "preact";

const EmptyList = () => <div>Geen resultaten gevonden</div>;

export default EmptyList;
